/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShowModelAtPointInTimeResponse
 */
export interface ShowModelAtPointInTimeResponse {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ShowModelAtPointInTimeResponse
     */
    data: { [key: string]: any; };
}

/**
 * Check if a given object implements the ShowModelAtPointInTimeResponse interface.
 */
export function instanceOfShowModelAtPointInTimeResponse(value: object): value is ShowModelAtPointInTimeResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowModelAtPointInTimeResponseFromJSON(json: any): ShowModelAtPointInTimeResponse {
    return ShowModelAtPointInTimeResponseFromJSONTyped(json, false);
}

export function ShowModelAtPointInTimeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowModelAtPointInTimeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'],
    };
}

  export function ShowModelAtPointInTimeResponseToJSON(json: any): ShowModelAtPointInTimeResponse {
      return ShowModelAtPointInTimeResponseToJSONTyped(json, false);
  }

  export function ShowModelAtPointInTimeResponseToJSONTyped(value?: ShowModelAtPointInTimeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'],
    };
}

